import filterConfigurations from "./filterConfigurations";

const isProductAvailableInConfigurations =
  (filteredConfiguration) => (availableProduct) => {
    if (!availableProduct) {
      return false;
    }

    return filteredConfiguration.some(
      ({ product }) =>
        product.sku === availableProduct.sku &&
        (!availableProduct.stock || availableProduct.stock.isInStock)
    );
  };

const addDisableBool = (configurations, options, selectedOptions) => {
  return options.map((option) => {
    return {
      ...option,
      values: option.values.map((optionValue) => {
        let filteredConfiguration;

        if (selectedOptions[option.attribute.id]) {
          const optionsWithoutCurrentOption = Object.assign(
            {},
            selectedOptions
          );
          delete optionsWithoutCurrentOption[option.attribute.id];

          filteredConfiguration = filterConfigurations(
            configurations,
            optionsWithoutCurrentOption
          );
        } else {
          filteredConfiguration = filterConfigurations(
            configurations,
            selectedOptions
          );
        }

        const disabled = !optionValue.availableProducts.some(
          isProductAvailableInConfigurations(filteredConfiguration)
        );

        return {
          ...optionValue,
          disabled: disabled,
        };
      }),
    };
  });
};

export default addDisableBool;
